import APP_CONFIG from '@/APP_CONFIG';
import type { App, Plugin } from 'vue';
import { isObject } from './is';

export const withInstall = <T>(component: T, alias?: string) => {
  const comp = component as any;
  comp.install = (app: App) => {
    app.component(comp.name || comp.displayName, component);
    if (alias) {
      app.config.globalProperties[alias] = component;
    }
  };
  return component as T & Plugin;
};
// 将182服务器的静态资源转到 https://zcxt.innpst.com
export function handleStatic(url: Nullable<string>) {
  if (!url) return '';
  if (APP_CONFIG.ENV == 'development') {
    return url;
  }
  return url.replace(APP_CONFIG.DEV_STATIC_URL, APP_CONFIG.PROD_STATIC_URL);
}

type LvTitle = '初级' | '中级' | '副高' | '正高' | '' | string;
type LvCode = '2204' | '2203' | '2202' | '2201' | '' | string;
interface LV {
  img: string;
  code: LvCode;
  title: LvTitle;
  color: string;
}

const primary = require('@/assets/imgs/certify/primary.png');
const intermediate = require('@/assets/imgs/certify/intermediate.png');
const senior = require('@/assets/imgs/certify/senior.png');
const unknown = require('@/assets/imgs/certify/unknown.png');

export function formatCertifyLv(code: LvCode): LV {
  let title = '';
  let img = unknown;
  let color = '#ccc';
  if (code == '2201') {
    title = '正高';
    img = senior;
    color = '#ff3346';
  } else if (code == '2202') {
    title = '副高';
    img = senior;
    color = '#fa541c';
  } else if (code == '2203') {
    title = '中级';
    img = intermediate;
    color = '#3a9ef1';
  } else if (code == '2204') {
    title = '初级';
    color = '#31d67d';
    img = primary;
  } else if (code == '2205') {
    title = '员级';
    // color = '#31d67d'
    img = primary;
  }
  return {
    title,
    code,
    img,
    color,
  };
}
// const s =
interface Code {
  color?: string;
  match?: string;
  title?: string;
  img?: string;
  code?: string;
}
const codes: Code[] = [
  {
    color: '#ff3346',
    match: '正',
    title: '正高',
    code: '2201',
    img: senior,
  },
  {
    color: '#fa541c',
    match: '副',
    title: '副高',
    code: '2202',
    img: senior,
  },
  {
    color: '#3a9ef1',
    match: '中',
    title: '中级',
    code: '2203',
    img: intermediate,
  },
  {
    color: '#31d67d',
    match: '员',
    title: '员级',
    code: '2204',
    img: primary,
  },
  {
    color: '#31d67d',
    match: '初',
    title: '初级',
    code: '2204',
    img: primary,
  },
];

const CODE_LIST = ['2201', '2202', '2203', '2204'];
export function getLv(title: string): Code {
  // 职称申报/考核定制
  if (CODE_LIST.includes(title)) {
    return codes.find((e) => title == e.code) as Code;
  }
  // 用户手填的
  return codes.find((e) => title.includes(e.title!)) as Code;
}

export function deepMerge<T = any>(src: any = {}, target: any = {}): T {
  let key: string;
  for (key in target) {
    src[key] = isObject(src[key]) ? deepMerge(src[key], target[key]) : (src[key] = target[key]);
  }
  return src;
}

export function deepClone(obj: Recordable) {
  const result = Object.assign({}, obj);
  Object.entries(result).forEach(([key, value]) => {
    if (typeof value === 'object') {
      result[key] = deepClone(value);
    }
  });
  return result;
}
